function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M21.9 20.724h-.367V18.07c0-.629-.492-1.138-1.1-1.138H19.7V9.724h-2.2v7.207h-2.2V9.724h-2.2v7.207h-2.2V9.724H8.7v7.207H6.5V9.724H4.3v7.207h-.733c-.608 0-1.1.51-1.1 1.138v2.655H2.1c-.608 0-1.1.51-1.1 1.138v.759c0 .21.164.379.367.379h21.266c.203 0 .367-.17.367-.38v-.758c0-.628-.492-1.138-1.1-1.138zm-2.567 0H4.667v-1.517h14.666v1.517zm3.313-15.312l-9.95-4.295a2.13 2.13 0 0 0-1.392 0l-9.95 4.295A.569.569 0 0 0 1 5.944v1.315a.56.56 0 0 0 .55.569h.917v.569a.56.56 0 0 0 .55.569h17.966a.56.56 0 0 0 .55-.57v-.568h.917a.56.56 0 0 0 .55-.57V5.945a.569.569 0 0 0-.354-.532zM3.2 6.69L12 3.276l8.8 3.414H3.2z"
});

var SvgUniversity = function SvgUniversity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUniversity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/university.2b9b7202.svg";
export { ForwardRef as ReactComponent };